import { ConditionalRenderer } from "components";
import styles from "./styles.module.scss";

export const FormLabel = ({ Icon, required, label, className }) => {
  return (
    <div className={`${styles.label} ${className}`}>
      <ConditionalRenderer condition={Icon}>
        <Icon style={{ height: "2dvh", width: "2dvh" }} />
      </ConditionalRenderer>
      <label>
        {label}
        {/* <ConditionalRenderer condition={required}>
          <span style={{ color: "red" }}>*</span>
        </ConditionalRenderer> */}
      </label>
    </div>
  );
};
